import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { AuthService } from '../../../auth/services/auth.service';
import { AuthForm } from '../../../auth/types/auth-form.type';
import { PatrolSigninFormComponent } from '../../components/patrol-signin-form/patrol-signin-form.component';

@Component({
  selector: 'app-patrol-auth',
  standalone: true,
  imports: [CommonModule, TranslatePipe, PatrolSigninFormComponent],
  templateUrl: './patrol-auth.component.html',
  styleUrl: './patrol-auth.component.scss',
})
export class PatrolAuthComponent {
  #authService = inject(AuthService);

  isPending = computed(() => this.#authService.signin.isPending());

  handleSignin(form: AuthForm): void {
    void this.#authService.signin.mutateAsync({ form, layout: 'patrol' });
  }
}
